export default __webpack_public_path__ + "static/media/typ.adf5ca3c.png";